import React from 'react';

export const CompletedIllustration = () => (
  <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <path
        d="M28.0322 61.269L27.3183 67.1518"
        stroke="#00005A"
        strokeWidth="1.16534"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2263 79.4539L12.7491 79.1195C12.6206 79.3028 12.6086 79.5435 12.718 79.7387C12.8274 79.9339 13.0389 80.0492 13.2623 80.0354L13.2263 79.4539ZM64.4226 76.2841L64.4586 76.8657C64.7294 76.8489 64.9528 76.6474 64.9973 76.3798C65.0419 76.1121 64.8958 75.8491 64.645 75.7456L64.4226 76.2841ZM28.3404 60.7511C28.043 60.6282 27.7023 60.7698 27.5795 61.0672C27.4566 61.3646 27.5982 61.7053 27.8956 61.8282L28.118 61.2896L28.3404 60.7511ZM17.0629 73.9774L16.5857 73.643L12.7491 79.1195L13.2263 79.4539L13.7035 79.7882L17.5401 74.3117L17.0629 73.9774ZM13.2263 79.4539L13.2623 80.0354L64.4586 76.8657L64.4226 76.2841L64.3865 75.7026L13.1903 78.8723L13.2263 79.4539ZM64.4226 76.2841L64.645 75.7456L28.3404 60.7511L28.118 61.2896L27.8956 61.8282L64.2001 76.8227L64.4226 76.2841Z"
        fill="#00005A"
      />
      <path
        d="M63.5564 76.2177L19.079 65.4885L24.7771 73.6101"
        stroke="#00005A"
        strokeWidth="1.16534"
        strokeLinejoin="round"
      />
    </g>
    <g opacity="0.8">
      <path
        d="M15.5918 31.557L14.4389 34.7467"
        stroke="#00005A"
        strokeWidth="0.83747"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00037 39.8008L4.72 39.4898C4.60054 39.5974 4.55332 39.764 4.59849 39.9184C4.64366 40.0727 4.77325 40.1876 4.93191 40.2139L5.00037 39.8008ZM33.963 44.6005L33.8945 45.0136C34.0869 45.0455 34.2758 44.9404 34.3501 44.7601C34.4244 44.5798 34.3644 44.3721 34.2055 44.2592L33.963 44.6005ZM15.8793 31.2383C15.6908 31.1043 15.4294 31.1486 15.2955 31.3371C15.1615 31.5256 15.2058 31.787 15.3943 31.921L15.6368 31.5796L15.8793 31.2383ZM7.84289 37.2383L7.56251 36.9273L4.72 39.4898L5.00037 39.8008L5.28074 40.1118L8.12326 37.5493L7.84289 37.2383ZM5.00037 39.8008L4.93191 40.2139L33.8945 45.0136L33.963 44.6005L34.0314 44.1874L5.06883 39.3877L5.00037 39.8008ZM33.963 44.6005L34.2055 44.2592L15.8793 31.2383L15.6368 31.5796L15.3943 31.921L33.7204 44.9419L33.963 44.6005Z"
        fill="#00005A"
      />
      <path
        d="M33.4892 44.4523L10.0572 32.762L12.1937 38.023"
        stroke="#00005A"
        strokeWidth="0.83747"
        strokeLinejoin="round"
      />
    </g>
    <g opacity="0.8">
      <path
        d="M76.6523 40.6884L77.6 45.1504"
        stroke="#00005A"
        strokeWidth="0.656662"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89.2417 53.6242L89.4929 53.4128C89.5741 53.5092 89.5929 53.6437 89.5412 53.7587C89.4895 53.8738 89.3765 53.949 89.2504 53.9524L89.2417 53.6242ZM49.7711 54.6772L49.7798 55.0054C49.627 55.0095 49.4916 54.9075 49.4532 54.7595C49.4149 54.6115 49.4838 54.4566 49.6194 54.386L49.7711 54.6772ZM76.4358 40.4187C76.5966 40.335 76.7949 40.3974 76.8787 40.5583C76.9624 40.7191 76.9 40.9174 76.7391 41.0011L76.5875 40.7099L76.4358 40.4187ZM85.9273 49.6861L86.1785 49.4747L89.4929 53.4128L89.2417 53.6242L88.9905 53.8356L85.6761 49.8975L85.9273 49.6861ZM89.2417 53.6242L89.2504 53.9524L49.7798 55.0054L49.7711 54.6772L49.7623 54.349L89.2329 53.296L89.2417 53.6242ZM49.7711 54.6772L49.6194 54.386L76.4358 40.4187L76.5875 40.7099L76.7391 41.0011L49.9227 54.9684L49.7711 54.6772Z"
        fill="#00005A"
      />
      <path
        d="M50.4301 54.5673L83.8033 43.3144L79.9868 49.9293"
        stroke="#00005A"
        strokeWidth="0.656662"
        strokeLinejoin="round"
      />
    </g>
    <path d="M2.22462 22.9454C36.9447 10.2113 88.7461 18.353 88.7461 18.353" stroke="#33337B" />
  </svg>
);
